import React from 'react';
import useFetchURL from '../../../../components/Hooks/useFetchURL';
import { uri } from '../../../../help/Api';
import { useHistory } from 'react-router-dom';
import TrunItemsAvgForm from './TrunItemsAvg-form';
import { useTranslation } from 'react-i18next';

 const createDefaultValues = (t) => ({
    branch: {id:-1, name:t("all")},  
    safe:{id:-1, name:t("all")},
    curr: {id:-1, name:t("all")},
  });

export default function TrunItemsAvg() {
  const { t } = useTranslation(["forms"]);
  const defaultValues = React.useMemo(() => createDefaultValues(t), [t]);

  let his = useHistory();
const [rptParams, setRptParams] = React.useState(defaultValues);

  const {data, fetching, fetchURL} = useFetchURL({...{
    url: uri+`RptSafes/trun-items-avg?branch=${rptParams.branch.id}
    &&safe=${rptParams.safe.id}
    &&item_No=${rptParams.curr.id}`,
    dependencyArray:[]
  }});

  const onChangeData =(propName)=>(event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };

  const printHandle = ()=>{
    const info ={...data, dateFrom: rptParams.dateFrom,
      dateTo: rptParams.dateTo}
    his.push({ pathname: '/', 
    state:info,});
    window.location.reload(false);
  }

  return (
    <TrunItemsAvgForm 
    {...{
      data:data? data: [],
      onChangeData,
      printHandle,
      rptParams,
      setRptParams,
      fetchURL,
      fetching,
    }}/>
  );




};